import React from 'react'
import './commonlst.css'

function CommonList({icon, title, description, key}) {
  return (
    <div className="wwd-list-col" key={key}>
        <div className="list-icon">
            <i class={`fal ${icon}`}></i>  
        </div>
        <div className="list-text">
            <h3>{title}</h3>
            <p>
            {description.split('\n').map((line, key) => (
              <React.Fragment key={key}>
              {line}
              <br />
              </React.Fragment>
            ))}
            </p>
        </div>
     </div>
  )
}

export default CommonList